import {MetaObjetivo} from "./metaObjetivo";

export class MetaAcao {

    id: number;
    metaObjetivo: MetaObjetivo;

}